import React from "react";
import Home from "./pages/Home.js";
import Login from "./pages/Login.js";
import ClassInfo from "./pages/ClassInfo.js";
import AdminInfo from "./pages/AdminInfo.js";
import Classes from "./pages/Classes.js";
import Assignments from "./pages/Assignments.js";
import { useEffect, useState } from "react";
import Navbar from "./components/Navbar/Navbar.js";
import { useUser } from "./globals/UserContext.js";
import TeacherOrStudentModal from "./components/Modals/TeacherOrStudentModal/TeacherOrStudentModal.js";
import AssignmentEditor from "./pages/AssignmentEditor.js";
import AssignmentReview from "./pages/AssignmentReview.js";

const App = () => {
  let user = useUser();

  const [page, setPage] = useState("classes");

  const [modalOpen, setModalOpen] = React.useState(true);
  // const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  if (Object.keys(user).length !== 0) {
    if (typeof user.isTeacher === "undefined") {
      return (
        <>
          <TeacherOrStudentModal
            open={modalOpen}
            setPage={setPage}
            setOpen={setModalOpen}
            handleClose={handleClose}
          ></TeacherOrStudentModal>
        </>
      );
    } else {
      return (
        <>
          <Navbar page={page} setPage={setPage} />
          {page === "home" && <Home setPage={setPage} />}
          {page === "adminInfo" && <AdminInfo setPage={setPage} />}
          {page === "classes" && <Classes setPage={setPage} />}
          {page === "classInfo" && <ClassInfo setPage={setPage} />}
          {page === "assignments" && <Assignments setPage={setPage} />}
          {page === "assignmentEditor" && (
            <AssignmentEditor setPage={setPage} />
          )}
          {page === "assignmentReview" && <AssignmentReview />}
        </>
      );
    }
  } else {
    return <Login />;
  }
};

export default App;
